import React from "react";

export const ProcedurePage = () => {
    return (
       <div>
        quy trinh
       </div>
    )
}